import Navbar from "../components/Navbar";
import '../styling/NewHome.css';
import drill from '../resources/drillimage.jpg';
import { Link } from "react-router-dom";
import computer from '../resources/computer.jpg';
import check from '../resources/check.png';
import revenue from '../resources/revenue.jpg';
import star from '../resources/star.png';


const NewHome = () => {
    return ( 
        <div className="newhomecontainer">
            <Navbar></Navbar>
            <div className="first">
                <div className="firstgreeting">
                    <h1 id="firsttrial">FREE 14-DAY TRIAL</h1>
                    <h1 id="firsteasy">Easy-to-use home service software for your business</h1>
                    <h1 id="firstwe">We make it easy to manage your home service business - from payments and scheduling, to estimates and dispatching</h1>
                    <Link to="/signup" style={{textDecoration: 'none'}} >
                    <button className="btn" id="firstbutton"><span>START FREE TRIAL</span></button>
                    </Link>
                </div>
                {/* <div className="firstimage">
                    <img src={drill} alt="" />
                </div>*/}
                <img src={drill} alt="" />
                
            </div>
            <div className="second">
                <h1 id="features">FEATURES YOU NEED</h1>
                <h1 id="scheduling">Scheduling. Estimates. Invoicing. Payments</h1>
            </div>
            <div className="third">
                <div className="thirdleft">
                    <img src={computer} alt="" />
                </div>
                <div className="thirdright">
                    <h1 id="thirdhome">HOME SERVICE PRO SCHEDULING SOFTWARE</h1>
                    <h1 id="thirdeasiest">The easiest way to schedule your jobs</h1>
                    <h1 id="thirdschedule">Your schedule is easy to maintain with a drag & drop calendar and real-time messaging to your employees and customers. Plus, with our integrated reporting you can make sure you're getting more of the jobs you want.</h1>
                    <div className="thirdbottom">
                        <div className="thirdbottomleft">
                            <img src={check} alt="" />
                            <img src={check} alt="" />
                            <img src={check} alt="" />
                            <img src={check} alt="" />
                        </div>
                        <div className="thirdbottomright">
                            <h1>Set up new and recurring jobs from the office or on the go</h1>
                            <h1>Notify and dispatch technicians and estimators</h1>
                            <h1>Manage comployee time tracking and stay on top of time cards</h1>
                            <h1>Send custom texts and auto-notifications</h1>
                        </div>
                        
                    </div>
                    <Link to="/signup" style={{textDecoration: 'none'}} >
                        <button className="btn btn-outline btn-info" id="thirdbutton">Get started</button>
                    </Link>
                </div>
            </div>

            <div className="fourth">
                <div className="fourthleft">
                <h1 id="thirdhome">HOME SERVICE PRO SCHEDULING SOFTWARE</h1>
                    <h1 id="thirdeasiest">The easiest way to schedule your jobs</h1>
                    <h1 id="thirdschedule">Your schedule is easy to maintain with a drag & drop calendar and real-time messaging to your employees and customers. Plus, with our integrated reporting you can make sure you're getting more of the jobs you want.</h1>
                    <div className="thirdbottom">
                        <div className="thirdbottomleft">
                            <img src={check} alt="" />
                            <img src={check} alt="" />
                            <img src={check} alt="" />
                            <img src={check} alt="" />
                        </div>
                        <div className="thirdbottomright">
                            <h1>Set up new and recurring jobs from the office or on the go</h1>
                            <h1>Notify and dispatch technicians and estimators</h1>
                            <h1>Manage comployee time tracking and stay on top of time cards</h1>
                            <h1>Send custom texts and auto-notifications</h1>
                        </div>
                        
                    </div>
                    <Link to="/signup" style={{textDecoration: 'none'}} >
                        <button className="btn btn-outline btn-info" id="thirdbutton">Get started</button>
                    </Link>

                </div>
                    <img src={revenue} alt="" id="revman"/>
            </div>
            <div className="five">
                <div className="fivetop">
                    <h1 id="fivepros">WHAT OUR PROS SAY</h1>
                    <h1 id="fiveimpress">Impress customers</h1>
                </div>
                <div className="fivebottom">
                    <div className="revleft">
                        <div className="revtop">
                        <img src={star} alt="" />
                        <img src={star} alt="" />
                        <img src={star} alt="" />
                        <img src={star} alt="" />
                        <img src={star} alt="" />
                        </div>
                        <h1>“There are just so many things that Housecall Pro does for us that a lot of it becomes automatic. It's a win-win.”</h1>
                        <p>Joe M.</p>
                        <p>Owner, Air Hawk Heating & Cooling</p>
                        <p>Pasco County, FL</p>
                    </div>
                    <div className="revleft">
                    <div className="revtop">
                        <img src={star} alt="" />
                        <img src={star} alt="" />
                        <img src={star} alt="" />
                        <img src={star} alt="" />
                        <img src={star} alt="" />
                        </div>
                        <h1>“There are just so many things that Housecall Pro does for us that a lot of it becomes automatic. It's a win-win.”</h1>
                        <p>Joe M.</p>
                        <p>Owner, Air Hawk Heating & Cooling</p>
                        <p>Pasco County, FL</p>
                    </div>
                </div>
                <div className="fivebottomtwo">

                </div>
                <div className="trustdiv">
                    <h1>GET IN TOUCH: 123-456-7890</h1>
                    <h2>Let us earn your trust</h2>
                    <Link to="/signup" style={{textDecoration: 'none'}} >
                    <button className="btn glass">Get started</button>
                    </Link>
                </div>
            </div>
            <footer className="footer footer-center p-10 bg-base-200 text-base-content rounded">
             <nav className="grid grid-flow-col gap-4">
                <a className="link link-hover">About us</a>
            <a className="link link-hover">Contact</a>
            <a className="link link-hover">Jobs</a>
            <a className="link link-hover">Press kit</a>
            </nav> 
            <nav>
            <div className="grid grid-flow-col gap-4">
            <a><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="fill-current"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"></path></svg></a>
            <a><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="fill-current"><path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"></path></svg></a>
            <a><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="fill-current"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path></svg></a>
            </div>
            </nav> 
            <aside>
            <p>Copyright © 2023 - All right reserved by InvoiceMasterPro Ltd</p>
            </aside>
            </footer>
        </div>
     );
}
 
export default NewHome;